module.exports = __webpack_public_path__ + "img/litecoin.e84b0f6e.png";